import { ArrowDownTrayIcon, Avatar, Flex, Menu, MenuProps, Text, UserIcon } from 'components'
import { useCurrentUser, useWorkspace } from 'components/providers'
import { useNavigate } from 'react-router'
import { signOut } from 'utils'

export interface Props extends MenuProps<string, false> {}

export default function UserProfile({ options = [], ...rest }: Props) {
  const user = useCurrentUser()
  const { workspace } = useWorkspace()
  const navigate = useNavigate()

  return (
    <Menu
      portal
      menuProps={{ positioning: { placement: 'bottom-end' } }}
      variant="ghost"
      buttonLabel={
        <Flex gap={2} alignItems={'center'}>
          <Avatar
            key={user?.photoUrl!}
            cursor="pointer"
            size="xs"
            name={user?.name!}
            src={user?.photoUrl!}
          />
          <Text fontSize="14px" textStyle="bodySmall">
            {user?.name! || user?.email}
          </Text>
        </Flex>
      }
      hideCheckbox
      options={[
        ...options,
        {
          value: 'profile' as string,
          onClick: () => navigate(`/${workspace?.id}/profile`),
          icon: <UserIcon type="outline" fontSize={'sm'} />,
          label: 'My Profile',
        },
        {
          value: 'logout' as string,
          onClick: () => signOut(),
          icon: <ArrowDownTrayIcon size="sm" style={{ transform: 'rotate(90deg)' }} />,
          label: 'Log Out',
        },
      ]}
      {...rest}
    />
  )
}
